module.exports = __webpack_public_path__ + "img/rku10-char-3.7d7cc0e8.png";